import Typography from '@mui/material/Typography';
import React from 'react';

const Copyright = () => {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {`Copyright © ${new Date().getFullYear()}. Universal College Lahore (UCL), Pakistan - All Rights Reserved`}
        </Typography>
    );
}
export default Copyright;